// extracted by mini-css-extract-plugin
export default {"wrapper":"MailingSenders_wrapper__5Zhoa","delete_wrapper":"MailingSenders_delete_wrapper__GMu4X"};